<ng-container *ngIf="widget">
  <div
    class="col-span-1 col-span-2 col-span-3 col-span-4 col-span-5 col-span-6 col-span-7 col-span-8 col-span-9 col-span-10 col-span-11 col-span-12"
  ></div>

  <div
    class="col-span-6 lg:col-span-6 md:col-span-12 sm:col-span-12 widgets_image xl:col-span-6"
  ></div>
  <div
    class="col-span-12 lg:col-span-4 md:col-span-12 sm:col-span-12 widgets_image xl:col-span-4"
  ></div>

  <div class="tx-services tx-services__wrapper w-full">
    <ng-container *ngIf="widget?.data.attributes?.Banner">
      <widget-banner [widget]="widget.data.attributes.Banner"></widget-banner>
    </ng-container>

    <div
      class="grid grid-cols-1 md:grid-cols-12 grid-flow-row gap-x-2 justify-center"
    >
      <ng-container
        *ngFor="
          let componenent of widget?.data?.attributes?.Components;
          let i = index;
          let first = first;
          let last = last
        "
      >
        <ng-container *ngIf="componenent.__component === 'widgets.image'">
          <div [class]="getResponviceClasses(widget)">
            <widget-image [widget]="componenent"></widget-image>
          </div>
        </ng-container>

        <ng-container *ngIf="componenent.__component === 'widgets.editor-text'">
          <widgets-editor-text [widget]="componenent"></widgets-editor-text>
        </ng-container>

        <ng-container
          *ngIf="componenent.__component === 'widgets.section-image-title-text'"
        >
          <widgets-image-title-text
            class="col-span-1 md:col-span-12"
            [widget]="componenent"
          ></widgets-image-title-text>
        </ng-container>
      </ng-container>
    </div>
  </div>
</ng-container>
